<template>
  <div>
    <agile-table
      :data-type="'products'"
      :data="products"
      :tableMeta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openProductModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import ProductModal from '@/components/modals/ProductModal'

export default {
  computed: {
    ...mapState({
      products: state => state.products.all
    })
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      filterMeta: [{
        fieldId: 'name',
        type: 'string',
        label: 'Namn'
      },
      {
        fieldId: 'invoiceText',
        type: 'string',
        label: 'Fakturatext'
      }, {
        fieldId: 'productType',
        label: 'Produkttyp',
        type: 'select',
        options: [{
          key: 'Rate',
          value: 'Taxa'
        }, {
          key: 'Rent',
          value: 'Hyra'
        }]
      }],

      tableMeta: {},

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'name',
          label: 'Namn'
        },
        {
          fieldId: 'invoiceText',
          label: 'Fakturatext'
        }, {
          fieldId: 'productType',
          label: 'Produkttyp',
          dataType: 'translate',
          translations: [{
            key: 'Rate',
            value: 'Taxa'
          }, {
            key: 'Rent',
            value: 'Hyra'
          }]
        }, {
          fieldId: 'invoiceItemGroupHeading',
          label: 'Gruppera',
          dataType: 'bool'
        }, {
          fieldId: 'aggregateHoursToTotal',
          label: 'Aggregera',
          dataType: 'bool'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateProduct',
          iconClass: 'fal fa-pen'
        }, {
          label: 'Radera',
          action: 'deleteProduct',
          iconClass: 'fal fa-trash'
        }]
      }
    }
  },

  components: {
    NewButton,
    AgileTable
  },

  watch: {
    'products.filter': {
      handler () {
        this.products.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('products', ['initialize', 'save', 'getListData', 'delete']),

    save () {
      this.save(this.products)
    },

    fieldAction (action, product) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    rowAction (action, product) {
      switch (action) {
        case 'updateProduct':
          this.openProductModal(product.productId)
          break
        case 'deleteProduct':
          this.$confirm(`Ta bort ${product.name}?`).then(ok => {
            if (ok) {
              this.delete(product.productId)
            }
          })
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openProductModal (productId) {
      this.$panel(ProductModal, { productId })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/ProductsPage.vue